// extracted by css-extract-rspack-plugin
export default {"pageHeaderWrapper":"_dbe8b7e","pageHeaderInnerWrapper":"_123c3340","pageHeaderTitle":"_ec77358d","pageHeaderDescription":"_f21455ab"};